import { coreBlue } from '../colorPalette';

export default {
  MuiIconButton: {
    root: {
      color: coreBlue,
    },
  },
};
